import MagnifyingGlassSvg from '../../../../../assets/images/ornament-wrapper/magnifying-glass.raw.svg';
import * as styles from '../OrnamentWrapper.styles';

export const MagnifyingGlass = () => <div css={styles.magnifyingGlassSvg(MagnifyingGlassSvg)} />;
